function isObject(o) {
    return o instanceof Object && o.constructor === Object;
}   

/*!
	Zoom 1.7.18
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

function niceAddress($addressFields, item, type){
    if(item && type === 'afd'){
        console.log('afd');
        // it's a lookup
        if(typeof item.Organisation !== 'object') { var organisation = item.Organisation; }
        if(typeof item.Property !== 'object') { var property = item.Property; }
        if(typeof item.Street !== 'object') { var street = item.Street; }
        if(typeof item.Town !== 'object') { var town = item.Town; }
        if(typeof item.Postcode !== 'object') { var postcode = item.Postcode; }

        if(organisation) {
            $addressFields.find('.companyname').val(organisation);
        }
        if(property){
            $addressFields.find('.line1').val(property);
            $addressFields.find('.line2').val(street);
        } else {
            $addressFields.find('.line1').val(street);
        }
        $addressFields.find('.city').val(town);
        $addressFields.find('.postcode').val(postcode);
        $addressFields.find('.country').val('GB');
            
        var niceAddress = '<strong>' + $('#firstname').val() + ' ' + $('#lastname').val() + '</strong><br>';
        if(organisation) { niceAddress = niceAddress + organisation + '<br>'; }
        if(property) { niceAddress = niceAddress + property + '<br>'; }
        if(street) { niceAddress = niceAddress + street + '<br>'; }
        if(town) { niceAddress = niceAddress + town + '<br>'; }
        if(postcode) { niceAddress = niceAddress + postcode + '<br>'; }
        niceAddress = niceAddress + 'United Kingdom';

        $addressFields.siblings('.address-block').children('address').html(niceAddress);
        $addressFields.siblings('.address-block').slideDown();
        $addressFields.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
    } else if(item) {
        // it's a user address choice
        if(typeof item.firstname !== 'object') { var firstname = item.firstname; } else { var firstname = $('#firstname').val() }
        if(typeof item.lastname !== 'object') { var lastname = item.lastname; } else { var lastname = $('#lastname').val() }
        if(typeof item.companyname !== 'object') { var companyname = item.companyname; }
        if(typeof item.line1 !== 'object') { var line1 = item.line1; }
        if(typeof item.line2 !== 'object') { var line2 = item.line2; }
        if(typeof item.city !== 'object') { var city = item.city; }
        if(typeof item.postcode !== 'object') { var postcode = item.postcode; }
        if(typeof item.country !== 'object') { var country = item.country; }

        // empty them all first in case they change it from one with some stuff to one without it
        $addressFields.find('.firstname').val('');
        $addressFields.find('.lastname').val('');
        $addressFields.find('.companyname').val('');
        $addressFields.find('.line1').val('');
        $addressFields.find('.line2').val('');
        $addressFields.find('.city').val('');
        $addressFields.find('.postcode').val('');
        $addressFields.find('.country').val('');

        $addressFields.find('.firstname').val(firstname);
        $addressFields.find('.lastname').val(lastname);
        if(companyname){ $addressFields.find('.companyname').val(companyname); }
        $addressFields.find('.line1').val(line1);
        if(line2){ $addressFields.find('.line2').val(line2); }
        $addressFields.find('.city').val(city);
        $addressFields.find('.postcode').val(postcode);
        $addressFields.find('.country').val(country);

        if($addressFields.find('.firstname').val().length || $addressFields.find('.lastname').val().length) {
            var niceAddress = '<strong>';
            if($addressFields.find('.firstname').val().length){
                niceAddress = niceAddress + firstname + ' ';
            }
            if($addressFields.find('.lastname').val().length){
                niceAddress = niceAddress + lastname;
            }
            niceAddress = niceAddress + '</strong><br>';
        } else {
            var niceAddress = '<strong>' + $('#firstname').val() + ' ' + $('#lastname').val() + '</strong><br>';
        }

        if($addressFields.find('.companyname').val().length) { niceAddress = niceAddress + $addressFields.find('.companyname').val() + '<br>'; }
        if($addressFields.find('.line1').val().length) { niceAddress = niceAddress + $addressFields.find('.line1').val() + '<br>'; }
        if($addressFields.find('.line2').val().length) { niceAddress = niceAddress + $addressFields.find('.line2').val() + '<br>'; }
        if($addressFields.find('.city').val().length) { niceAddress = niceAddress + $addressFields.find('.city').val() + '<br>'; }
        if($addressFields.find('.postcode').val().length) { niceAddress = niceAddress + $addressFields.find('.postcode').val() + '<br>'; }
        if($addressFields.find('.country option:selected').length){ niceAddress = niceAddress + $addressFields.find('.country option:selected').html(); }
        $addressFields.siblings('.address-block').children('address').html(niceAddress);
        
        $addressFields.siblings('.address-block').children('address').html(niceAddress);
        $addressFields.siblings('.address-block').slideDown();
        $addressFields.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
    } else {
        // it's an edit
        var niceAddress = '';
        if($addressFields.find('.firstname').val().length) { niceAddress = niceAddress + '<strong>' + $addressFields.find('.firstname').val() + ' '; }
        if($addressFields.find('.lastname').val().length) { niceAddress = niceAddress + $addressFields.find('.lastname').val() + '</strong><br>'; }
        if($addressFields.find('.companyname').val().length) { niceAddress = niceAddress + $addressFields.find('.companyname').val() + '<br>'; }
        if($addressFields.find('.line1').val().length) { niceAddress = niceAddress + $addressFields.find('.line1').val() + '<br>'; }
        if($addressFields.find('.line2').val().length) { niceAddress = niceAddress + $addressFields.find('.line2').val() + '<br>'; }
        if($addressFields.find('.city').val().length) { niceAddress = niceAddress + $addressFields.find('.city').val() + '<br>'; }
        if($addressFields.find('.postcode').val().length) { niceAddress = niceAddress + $addressFields.find('.postcode').val() + '<br>'; }
        if($addressFields.find('.country option:selected').length){ niceAddress = niceAddress + $addressFields.find('.country option:selected').html(); }
        $addressFields.siblings('.address-block').children('address').html(niceAddress);
    }
}

$(document).ready(function(){
// form tokens
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    
    $('.page input[name="_token"], .custom-form input[name="_token"]').val($('meta[name="csrf-token"]').attr('content'));

// form validation
    $('#main-content form').submit(function(){
        var rv = true;
        $('input, select').each(function(){
            if($(this).data('required') === 'required' && $(this).val().trim().length === 0){
                rv = false;
            }
        });
        if(!rv){
            alert(validationErrorMsg);
        }
        return rv;
    });
    
    // re-add old inputs (can't use old() in form as it's just html). this should never fire as validation handles on at the client side but worth having in case
    if(typeof hasOld !== 'undefined'){
        $('#main-content form .form-control').each(function(){
            var name = $(this).attr('name');
            var oldInputVar = 'old_'+name;
            $(this).val(window[oldInputVar]);
        });
    }
    
// age checks
	// autotab
	$('#dob-select input[type="text"]').keyup(function(){
        if(this.value.length == this.maxLength) {
			$(this).parents('.form-group').nextAll('.form-group').first().children('input[type="text"]').focus();
		}
    });

// basket terms
    if($('#basket-terms-checkbox').length){
        $('#basket-terms-modal').appendTo('body');

        $('#basket footer.buttons .btn-primary').click(function(){
            var termsCheckbox = $('#basket-terms-checkbox').prop('checked');

            var rv = true;
            
            if(!termsCheckbox){
                alert('Please confirm you agree to the terms and conditions of purchase');
                rv = false;
            }

            var deliveryTermsCheckbox = $('#basket-xmas-delivery-terms-checkbox').prop('checked');
            
            if(!deliveryTermsCheckbox){
                alert('Please confirm you understand the Christmas/New Year delivery schedule');
                rv = false;
            }

            if(rv && $('#review-personalisation').length){
                $('#review-personalisation-modal-1').modal('show');

                $('.review-personalisation-next').click(function(){
                    var index = $(this).parents('.modal').data('index');
                    $('#review-personalisation-modal-' + parseInt(index+1, 10)).modal('show');
                });
                
                return false;
            }

            return rv;
        });
    }
    
// checkout: international address form toggle
    $('.non-uk-address a').click(function(){
        $(this).parents('p').siblings('.address-fields').slideDown();
    });

// checkout: postcode lookups
    // capture enter in postcode box to stop the form submitting (easily done)
    $('#dispatch-postcode-lookup, #invoice-postcode-lookup').keypress(function(e){
        if(e.which === 13){
            e.preventDefault();
        }
    });
    
    $('.postcode-lookup-button').click(function(){
        if($('#firstname').val().length === 0 || $('#firstname').val().length === 0){
            alert('Please enter your name in the Personal Details panel before finding your address');
            return false;
        }
        
        // this is the button...
        var $button = $(this);
        var $buttonText = $(this).text();
        // tell the user something's happening...
        $button.prepend('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> ').addClass('postcode-active');
        // get the postcode
        var postcodeToLookup = $button.parents('.input-group').find('.postcode-lookup').val();
        
        $.getJSON('/basket/postcodelookup', { postcode: postcodeToLookup }, function(data){
            // placeholder
            var options = '<option value="" selected="selected">Please select your address</option>';
            
            // if there ws a problem, flash a message, otherwise...
            if(data[0] === 'error'){
                $button.removeClass('.postcode-active').addClass('btn-danger').html('Postcode Not Found');
                setTimeout(
                  function(){ $button.removeClass('btn-danger').html('Get Address') }
                , 2000);
            } else {
                // for each returned address, assign a friendly one to output with commas and store the other one plain. make a blank if they don't exist for output.
                if(!isObject(data.Item)) // more than one has been returned
                    $.each(data.Item, function(key, item){
                        if(typeof item.Organisation !== 'object') { var organisation = item.Organisation + ', '; var organisationOutput = item.Organisation + ', '; } else { var organisationOutput = ''; }
                        if(typeof item.Property !== 'object') { var property = item.Property; var propertyOutput = item.Property + ', '; } else { var propertyOutput = ''; }
                        if(typeof item.Street !== 'object') { var street = item.Street; var streetOutput = item.Street + ', '; } else { var streetOutput = ''; }
                        if(typeof item.Town !== 'object') { var town = item.Town; var townOutput = item.Town + ', '; } else { var townOutput = ''; }
                        if(typeof item.PostalCounty !== 'object') { var postalCounty = item.PostalCounty; var postalCountyOutput = item.PostalCounty + ', '; } else { var postalCountyOutput = ''; }
                        if(typeof item.Postcode !== 'object') { var postcode = item.Postcode; } else { var postcode = ''; }

                        // build the option...
                        var option = '<option value="' + item.Key + '">' + organisationOutput + propertyOutput + streetOutput + townOutput + postalCountyOutput + postcode + '</option>';
                        // and put it with the rest
                        options = options + option;
                    });
                else {
                    if(typeof data.Item.Organisation !== 'object') { var organisation = data.Item.Organisation + ', '; var organisationOutput = data.Item.Organisation + ', '; } else { var organisationOutput = ''; }
                    if(typeof data.Item.Property !== 'object') { var property = data.Item.Property; var propertyOutput = data.Item.Property + ', '; } else { var propertyOutput = ''; }
                    if(typeof data.Item.Street !== 'object') { var street = data.Item.Street; var streetOutput = data.Item.Street + ', '; } else { var streetOutput = ''; }
                    if(typeof data.Item.Town !== 'object') { var town = data.Item.Town; var townOutput = data.Item.Town + ', '; } else { var townOutput = ''; }
                    if(typeof data.Item.PostalCounty !== 'object') { var postalCounty = data.Item.PostalCounty; var postalCountyOutput = data.Item.PostalCounty + ', '; } else { var postalCountyOutput = ''; }
                    if(typeof data.Item.Postcode !== 'object') { var postcode = data.Item.Postcode; } else { var postcode = ''; }

                    // build the option...
                    var option = '<option value="' + data.Item.Key + '">' + organisationOutput + propertyOutput + streetOutput + townOutput + postalCountyOutput + postcode + '</option>';
                    // and put it with the rest
                    options = options + option;
                }
                
                // put the options in the select box
                $button.parents('.form-group-postcode-lookup').siblings('.form-group-address-lookup-dropdown').find('.address-dropdown').html(options);
                // and show it
                $button.parents('.form-group-postcode-lookup').siblings('.form-group-address-lookup-dropdown').slideDown();
                // reset the button back to how it was
                $button.removeClass('.postcode-active').text($buttonText);
            }
        });
    });

// checkout: post-postcode address selection
    $('.address-dropdown').change(function(){
        // this is the dropdown
        var $dropdown = $(this);
        // and having the address fields is handy, too
        var $addressFields = $dropdown.parents('.form-group-address-lookup-dropdown').siblings('.address-fields');
        // this is the key to lookup
        var keyToLookup = $dropdown.val();
        
        // get the info
        $.getJSON('/basket/addresslookup', {key: keyToLookup}, function(item){
            $addressFields.find('.firstname').val($('#firstname').val());
            $addressFields.find('.lastname').val($('#lastname').val());
            
            niceAddress($addressFields, item, 'afd');
        });
        
        $dropdown.parents('.form-group-address-lookup-dropdown').siblings('.form-group-user-address').find('select').val('');
        $dropdown.parents('.form-group-address-lookup-dropdown').slideUp();
    });
    
    $('.edit-address a').click(function(){
        $(this).parents('.address-block').siblings('.address-fields').slideDown();
        $(this).parents('.address-block').slideUp();
        $(this).parents('.address-block').siblings('.invoice-address-checkbox').slideUp();
    });
    
    $('.address-edited a').click(function(){
        $addressFields = $(this).parents('.address-fields');
        $addressFields.slideUp();
        
        niceAddress($addressFields);
        
        $addressFields.siblings('.address-block, .invoice-address-checkbox').slideDown();
    });
    
    if($('#dispatch-postcode-lookup').length){
        if($('#dispatch-postcode-lookup').val().length){
            $addressFields = $('#checkout-delivery-info .address-fields');
        
            niceAddress($addressFields);

            $addressFields.siblings('.address-block').slideDown();
            $addressFields.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
            $addressFields.siblings('.form-group-address-dropdown, .non-uk-address').slideUp();
        }

        if($('#enquiry-delivery-info').val().length){
            $addressFields = $('#enquiry-delivery-info .address-fields');
            niceAddress($addressFields);

            $addressFields.siblings('.address-block').slideDown();
            $addressFields.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
            $addressFields.siblings('.form-group-address-dropdown, .non-uk-address').slideUp();
        }


    }
    
    if($('#invoice-postcode-lookup').length){
        if($('#invoice-postcode-lookup').val().length){
            $addressFields = $('#checkout-invoice-info .address-fields');

            niceAddress($addressFields);

            $addressFields.siblings('.address-block').slideDown();
            $addressFields.siblings('.invoice-address-checkbox, .recipient-name').slideDown();
            $addressFields.siblings('.form-group-address-dropdown, .non-uk-address').slideUp();
        }
    }

    $('#user-dispatch-address, #user-invoice-address').change(function(){
        // this is the dropdown
        var $dropdown = $(this);
        // and having the address fields is handy, too
        var $addressFields = $dropdown.parents('.form-group-user-address').siblings('.address-fields');
        // this is the key to lookup
        var keyToLookup = $dropdown.val();

        $.getJSON('/basket/useraddresslookup', {key: keyToLookup}, function(item){
            niceAddress($addressFields, item);
        });
    });

    if($('#user-dispatch-address').length){
        $('#user-dispatch-address').trigger('change');
    }

    if($('#user-invoice-address').length){
        $('#user-invoice-address').trigger('change');
    }

// additional freefield character count
    var maxFreefieldChars = 100;
    if($('#additional-freefield').length){
        $('.maxFreefieldChars').text(maxFreefieldChars - $('#additional-freefield').val().length);

        $('#additional-freefield').keyup(function(){
            $('#additional-freefield-charcount .maxFreefieldChars').text(maxFreefieldChars - $(this).val().length);
        });
    }

// vat/eori stuff
    if($('#checkout-vat-eori').length){
        $('#dispatch-country').trigger('change');
        $('#dispatch-country').on('change', function(){
            var countrycode = this.value;
            if(countrycode !== 'GB'){
                $('#checkout-vat-eori').removeClass('hidden');
                $('#checkout-vat-eori label .required').removeClass('hidden');
                $('#additional_vat_eori').attr('required', true);
            } else {
                $('#checkout-vat-eori').addClass('hidden');
                $('#checkout-vat-eori label .required').addClass('hidden');
                $('#additional_vat_eori').removeAttr('required');
            }
        });
    }
    
// checkout validation
    $('.checkout-info-form').submit(function(){
        var firstname = $('#dispatch-firstname').val();
        if(firstname.trim().length === 0){
            alert('Please ensure you have entered your postcode and chosen an address');
            return false;
        }
    });

// checkout review terms
    if($('#review-terms-checkbox').length){
        $('#review-terms-modal').appendTo('body');

        $('.place-order-button, #card-button').click(function(){
            var checkbox = $(this).siblings('.checkbox').children('#review-terms-checkbox').prop('checked');
            
            if(!checkbox){
                alert('Please confirm you agree to the terms and conditions of purchase');
                return false;
            }
        });
    }

    
// instant search
    $(document).on('focus, click', '#header .search-placeholder, #header .search-icon', function(){
        var val = $(this).val();
        if(!val.length) { $('.search-results').hide(); } 
        $('#search-results-wrapper').slideDown();
        
        $('#search-results-wrapper input').focus().keyup(function(){
            var val = $(this).val();
            $('#header .search-placeholder').val(val);
            var qLength = $(this).val().length;
            if(qLength > 0){
                $('.search-results').slideDown(750);
            } else {
                $('.search-results').slideUp();
            }
        });
    });
    
    $('#search-results-wrapper .search-close').click(function(){
        $('#search-results-wrapper').slideUp();
    });

// disable place order buttons on click
    // jQuery plugin to prevent double submission of forms (https://stackoverflow.com/questions/2830542/prevent-double-submission-of-forms-in-jquery)
    jQuery.fn.preventDoubleSubmission = function() {
      $(this).on('submit',function(e){
        var $form = $(this);

        if ($form.data('submitted') === true) {
          // Previously submitted - don't submit again
          e.preventDefault();
        } else {
          // Mark it so that the next submit can be ignored
          $form.data('submitted', true);
        }
      });

      // Keep chainability
      return this;
    };
    $('body.review form').preventDoubleSubmission();

// user management additional information
    // addition
    var newAttributeCount = 1;
    $('#add-new-attribute').click(function(){
        var newAttributeHtml = '<div class="row mb15"><div class="col-xs-5"><input name="new_key_' + newAttributeCount + '" type="text" class="form-control" list="additional-keys" required></div> <div class="col-xs-5"><input name="new_value_' + newAttributeCount + '" type="text" class="form-control" required></div><div class="col-xs-2"><a href="javascript:;" class="remove-attribute text-danger"><i aria-hidden="true" class="fa fa-2x fa-times-circle"></i></a></div></div>';
        $('#new-attributes').append(newAttributeHtml);
        newAttributeCount++;
    });

    // deletion
    $('#manageuser-additional').on('click', '.remove-attribute', function(){
        $(this).parent('div').parent('.row').remove();        
    });
});